<template>
  <div class="subscribe-dialog" v-show="showDialog">
    <div class="subscribe-dialog-bg" @click="showDialog = false"></div>
    <div class="cx-dialog-main">
      <div class="cx-dialog-title">
        <h3>选择您要订阅的消息分类</h3>
        <p>订阅后，您选择的消息分类会出现在门户首页-校内信息中</p>
        <span class="icon-portal-close close" @click="showDialog = false"></span>
      </div>
      <div class="cx-dialog-contant">
        <div class="content-title">应用名称</div>
        <div class="subscribe-lists">
          <el-scrollbar ref="scrollbar">
            <el-checkbox-group v-model="checkList">
              <el-checkbox
                v-for="(list, index) in allList"
                :key="list.id"
                :label="list.name"
                :disabled="list.name.indexOf('最新消息') > -1 ? true : false"
              ></el-checkbox>
            </el-checkbox-group>
          </el-scrollbar>
        </div>
      </div>
      <div class="cx-dialog-bottom">
        <el-button class="dialog-cancle" @click="showDialog = false">取消</el-button>
        <el-button class="dialog-confirm" @click="submitSubscribe">订阅</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "subscribeDialog",
  data() {
    return {
      showDialog: true,
      checkList: [],
      allList: []
    }
  },
  created() {
    this.getClassify()
  },
  mounted() {},
  methods: {
    getClassify() {
      let checkedList = sessionStorage.getItem("checkedList")
      sessionStorage.removeItem("checkedList")
      if (checkedList) {
        this.checkList = []
        checkedList = JSON.parse(checkedList)
        checkedList?.forEach(item => {
          this.checkList.push(item.name)
        })
      }
      if (this.instance) {
        this.instance({
          method: "post",
          // 本地使用这个接口，nginx 转发到章胜电脑
          // url: `engine2/form/classifys`,
          // // 下面的参数需要写死
          // data: {
          //   wfwfid: "208799",
          //   preParams: "formId=623894&PrimaryClassify=9"
          // }
          // url: `mhadapter/universal-cors/1dbf78cd7e5f4050a4837f7e7f3223bb`
          url: `app/data-source/bsd-all-classify`
        })
          .then(res => {
            if (res.data.code === 1) {
              this.allList = []
              let classifies = res.data.data.classifies
              let newMessageIndex = classifies.findIndex(item => item.name.indexOf("最新消息") > -1)
              // 对当前选中的分类进行一次筛选
              for (let i = 0; i < this.checkList.length; i++) {
                let selectedName = this.checkList[i].trim()
                let selectedIndex = classifies.findIndex(item => item.name.trim() === selectedName)
                if (selectedIndex === -1) {
                  this.checkList.splice(i, 1)
                  i--
                }
              }

              if (newMessageIndex > -1) {
                // 表示当前配置了最新消息，最新消息要放第一个
                this.allList.push(classifies[newMessageIndex])
                classifies.splice(newMessageIndex, 1)
                this.allList = this.allList.concat(classifies)
                if (!this.checkList.includes("最新消息")) {
                  this.checkList.unshift("最新消息")
                }
              }else{
                this.allList = classifies
              }
            }
          })
          .catch(err => {})
      }
    },
    submitSubscribe() {
      let data = ""
      if (this.checkList.includes("最新消息") && this.checkList[0].indexOf("最新消息") === -1) {
        // 存在，并且不在第一位的时候，处理为第一个
        let newMessageIndex = this.checkList.findIndex(item => item.indexOf("最新消息") > -1)
        this.checkList.splice(newMessageIndex, 1)
        this.checkList.unshift("最新消息")
      }
      this.checkList.forEach(item => {
        let newItem = data.length > 0 ? `,${item}` : `${item}`
        data += newItem
      })
      this.instance({
        method: "get",
        url: `app/data-source/bsd-save-classify`,
        params: {
          classify: data
        }
      })
        .then(res => {
          if (res.data.code === 1) {
            this.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              type: "success",
              message: "修改成功"
            })
            this.showDialog = false
          }
        })
        .catch(err => {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "error",
            message: "修改失败"
          })
          this.showDialog = false
        })
    }
  }
}
</script>

<style scoped>
.subscribe-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}

.subscribe-dialog-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: rgba(16, 26, 41, 0.7);
}

.cx-dialog-main {
  position: absolute;
  z-index: 2;
  width: 640px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
}

.cx-dialog-title {
  position: relative;
  padding: 8px 18px;
  box-sizing: border-box;
  border-bottom: 1px solid #f2f2f2;
}

.cx-dialog-title .close {
  position: absolute;
  top: 12px;
  right: 15px;
  color: #acb4bf;
  font-size: 20px;
  cursor: pointer;
  font-weight: 900;
}

.cx-dialog-title h3 {
  font-weight: 900;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 5px;
}

.cx-dialog-title p {
  color: #8b8b8b;
  font-size: 14px;
}

.cx-dialog-contant {
  padding: 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #f2f2f2;
}

.content-title {
  background: #f2f4f7;
  border-radius: 2px;
  font-weight: 900;
  font-size: 14px;
  line-height: 40px;
  color: #8a8b99;
  padding: 0 20px;
  box-sizing: border-box;
}

.subscribe-lists {
  height: 220px;
  overflow: hidden;
}
::v-deep .el-scrollbar {
  height: 220px;
}
::v-deep .el-scrollbar__wrap {
  overflow-y: scroll;
  overflow-x: scroll;
  height: calc(100% + 16px);
  margin-bottom: 0 !important;
}

::v-deep .el-checkbox-group .el-checkbox {
  display: block;
  line-height: 54px;
  margin-right: 0;
  padding: 0 21px;
  box-sizing: border-box;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label,
::v-deep .el-checkbox__label {
  color: #131b26;
}

::v-deep .el-checkbox-group .el-checkbox:hover {
  background-color: #f7f8fa;
}

.cx-dialog-bottom {
  padding: 16px 30px;
  text-align: right;
}

.cx-dialog-bottom .el-button {
  width: 92px;
  height: 36px;
  line-height: 34px;
  border-radius: 6px;
  padding: 0;
  margin-left: 32px;
  font-weight: 900;
}

.cx-dialog-bottom .dialog-confirm {
  background: var(--themeColor);
  border-color: var(--themeColor);
  color: #fff;
}

.cx-dialog-bottom .dialog-confirm:hover {
  background: var(--primaryButtonHover);
}

::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background: var(--themeColor);
  border-color: var(--themeColor);
}
</style>
